<template>
  <section class="section videos">
    <div class="modal" :class="{'is-active': flagvideoModal}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <form class="new_video">
            <h2>Nuevo Video</h2>
            <input class="input" v-model="videoUrl"  :class="{'is-danger': !validateUrl && trigger}" type="text" placeholder="Link de video">
            <button class="button is-warning is-rounded" :class="{'is-loading': loading}" @click.prevent="checkVideo()">Guardar</button>
          </form>
        </div>
      </div>
      <button class="modal-close" aria-label="close" @click="flagvideoModal = false">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <div class="container">
      <div class="level">
        <h1 class="title level-left">Galeria Videos</h1>
        <a class="button level-right is-warning is-rounded" v-if="videosList.length < 15"  @click="flagvideoModal = true">
          <span class="icon is-small">
            <ion-icon name="add-outline"></ion-icon>
          </span>
          <span>
            Nueva Video
          </span>
        </a>
      </div>

      <div class="card empty" v-if="!videosList.length">
        <div class="empty_wrapper">
          <img src="@/assets/img/empty_images.svg">
          <p> Todavia no hay videos </p>
        </div>
      </div>
      <div v-else class="card_grid" >
        <article class="card" v-for="video in videosList"  :key="video.id" :class="{selected: lastVideoInitial == video.id }" >
          <div class="thumb">
            <a :href="video.url" target="_blank" class="play_button_overlay">
              <div class="play_button">
                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 15 17" fill="none">
                  <path d="M15 8.55909L0.450607 16.5774L0.450608 0.540815L15 8.55909Z"  fill="#34498B"/>
                </svg>
              </div>
            </a>
            <img width="100" loading="lazy" :src="'https://img.youtube.com/vi/'+getVideoId(video.url)+'/mqdefault.jpg'" />
          </div>
          <div class="bottom">

            <div class="switch_wrapper">
              <label class="switch">
                <input type="radio" @change="setInitial(video)" :checked="lastVideoInitial == video.id" name="initial" >
                <span class="slider round"></span>
              </label>
            </div>
            <a @click="deletevideo(video)" class="remove_video">
              <ion-icon name="trash-outline"></ion-icon>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { firestore } from '@/main'
// import moment from 'moment'
export default {
  data: () => ({
    flagvideoModal: false,
    videosList: [],
    videoUrl: '',
    loading: false,
    trigger: false,
    lastVideoInitial: ''
  }),
  mounted() {
    this.getAllvideos()
  },
  methods: {
    setInitial (video) {
      if (this.lastVideoInitial) {
        firestore.collection("videos").doc(this.lastVideoInitial).update({
          initial: false
        })
        .then(() => {
          this.lastVideoInitial = video.id
          firestore.collection("videos").doc(video.id).update({
            initial: true
          })
          .then((res) => {
            video.initial = true
            console.log(res)
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          })
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        })
      } else {
        this.lastVideoInitial = video.id
        firestore.collection("videos").doc(video.id).update({
          initial: true
        })
        .then((res) => {
          console.log(res)
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        })
      }
    },
    getAllvideos() {
      firestore
        .collection('videos')
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            this.videosList.push({
              id: doc.id,
              url: data.url,
              initial: data.initial || false
            })
          })
          const { id } = this.videosList.find(v => v.initial == true)
          if (id) this.lastVideoInitial = id
        })
        .catch(console.error)
    },
    deletevideo({id, initial}) {
      if ( confirm('¿Seguro que quieres eliminar esta video?') ) {
        firestore.collection("videos").doc(id).delete().then(() => {
          this.videosList = this.videosList.filter(i => i.id !== id)
          if (initial) this.lastVideoInitial = ''
        })
        .catch((error) => {
          console.error("Error removing document: ", error)
        })
      }
    },
    checkVideo () {
      this.trigger = true
      if (this.validateUrl) {
        this.trigger = false
        this.storevideo()
      }
    },
    storevideo () {
      firestore.collection("videos").add({
        url: this.videoUrl,
        initial: false
      })
      .then((res) => {
        this.videosList.push({
          id: res.id,
          url: this.videoUrl,
          initial: false
        })
        this.flagvideoModal = false
        this.loading = false
        this.videoUrl = ''
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
    },
    getVideoId (url) {
      const code = url.match(/v=([^&#]{5,})/)
      if (code) return (typeof code[1] == 'string') ? code[1] : false;
      else return false
    }
  },
  computed: {
    validateUrl () {
      return this.getVideoId(this.videoUrl)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "bulma"
@import '../../assets/css/switch'
@import '../../assets/css/_variables.sass'
.videos
  .empty
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    min-height: 300px
    .empty_wrapper
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      p
        text-align: center
        font-weight: 500
        margin-top: 20px
        font-size: 14px
      img
        width: 150px
        margin-right: -40px
  .card_grid
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
    grid-gap: 20px
    .card
      position: relative
      padding: 15px
      display: flex
      align-items: center
      flex-direction: column
      box-shadow: 0 0px 0 1px rgba(10, 10, 10, 0.02) !important
      &.selected
        border-bottom: 4px solid #ffdd57
        box-sizing: border-box
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02) !important
      .remove_video
        width: 36px
        height: 36px
        border-radius: 50%
        display: flex
        justify-content: center
        align-items: center
      .switch_wrapper
        display: flex
        flex-direction: row
        align-items: center
        .switch
          transform: scale(.8)
          margin-left: -5px
      .bottom
        display: flex
        align-items: center
        justify-content: space-between
        width: 100%
        margin-top: 5px
      .thumb
        width: 100%
        position: relative
        .play_button_overlay
          background-color: rgba($primary_color, .5)
          width: 100%
          height: 100%
          position: absolute
          left: 0
          top: 0
          display: flex
          justify-content: center
          align-items: center
          .play_button
            width: 36px
            height: 36px
            border-radius: 50%
            background-color: white
            display: flex
            justify-content: center
            align-items: center
            z-index: 3
            cursor: pointer
            svg
              width: 8px
        img
          display: block
          height: 100px
          width: 100%
          object-fit: cover
          border-radius: 5px
  .modal-content
    width: 650px
    .new_video
      padding: 40px
      display: grid
      grid-template-columns: 1fr
      grid-gap: 20px
      .dropzone_content
        width: 100%
        box-sizing: border-box
        position: relative
        .dropzone
          height: 300px
        img
          position: absolute
          left: 0
          top: 0
          width: 100%
          height: 100%
          object-fit: cover
          border-radius: 5px
          width: calc(100% - 30px)
          height: calc(100% - 30px)
          margin: 15px
        .dropzone
          width: 100%
          height: 250px
          background-color: transparent
          border-radius: 5px
          border: 1px dashed darken(#F4F7F8, 10%)
          display: flex
          justify-content: center
          align-items: center
          cursor: pointer
          transition: all ease-in-out .2s
          padding: 20px
          box-sizing: border-box
          position: relative
          z-index: 2
          .open_file, .file_selected
            display: flex
            align-items: center
            background-color: white
            padding: 7px
            padding-right: 25px
            border-radius: 30px
          .file_selected
            small
              font-size: 12px
              font-weight: 400
              margin-top: 2px
              display: block
              b
                color: red
          .upload
            background-color: darken(#F4F7F8, 5%)
            width: 40px
            min-width: 40px
            height: 40px
            border-radius: 50%
            display: flex
            justify-content: center
            align-items: center
            margin-right: 15px
            i
              color: #3273DC
          h1
            font-size: 14px
            font-weight: 500
            p
              line-height: 1.3
              overflow: hidden
              text-overflow: ellipsis
              display: -webkit-box
              -webkit-line-clamp: 1
              -webkit-box-orient: vertical
            strong
              color: #3273DC
          &.ready, &:hover
            background-color: rgba(#F4F7F8, .7)
            border: 1px dashed #3273DC
  .button, .input
    box-sizing: border-box
  h2
    font-weight: 700
  h1
    font-size: 20px
  table
    width: 100%
    .thumb
      display: flex
      align-items: center
      img
        border-radius: 5px
      p
        margin-left: 20px
</style>